import React from 'react';
import {connect} from "react-redux";
import {withRouter, NavLink} from 'react-router-dom'
import {
    EvenIcon,
    FileTextIcon,
    GuestsIcon,
    HouseIcon,
    MailIcon,
    NotesListIcon,
    UserManagementIcon,
    TranslationsIcon, GearIcon
} from '../../../Components/Icons/Icons';
import EventNavigation from '../../AdminMultiEvent/EventNavigation';
import classnames from 'classnames';

import './navigation.scss';


const Navigation = ({ currentEvent, match, ...props }) => {

    return (
        <div className={classnames(['navigation', {noEvent: !currentEvent}])}>
            <ul className="main-menu">
                <li className="event-menu">
                    <EventNavigation />
                </li>
                <li>
                    <NavLink
                        activeClassName="active"
                        to="/dashboard"
                    >
                        <HouseIcon />
                        <span>Dashboard</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        activeClassName="active"
                        to="/event"
                    >
                        <EvenIcon />
                        <span>Event Setup</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        isActive={() => match?.url === '/guests'}
                        activeClassName="active"
                        to="/guests/all"
                    >
                        <GuestsIcon />
                        <span>Guest management</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        activeClassName="active"
                        to="/inventory"
                    >
                        <NotesListIcon />
                        <span>Inventory management</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        activeClassName="active"
                        to="/communication"
                    >
                        <MailIcon />
                        <span>Communication</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink
                        activeClassName="active"
                        to="/reports"
                    >
                        <FileTextIcon />
                        <span>Reports</span>
                    </NavLink>
                </li>

                <li>
                    <NavLink
                        activeClassName="active"
                        to="/multilang"
                    >
                        <TranslationsIcon />

                        <span>Translations</span>
                    </NavLink>
                </li>

                <li>
                    <NavLink
                        activeClassName="active"
                        to="/users"
                    >
                        <UserManagementIcon />
                        <span>User Management</span>
                    </NavLink>
                </li>

                <li>
                    <NavLink
                        activeClassName="active"
                        to="/settings"
                    >
                        <GearIcon />
                        <span>Settings</span>
                    </NavLink>
                </li>
            </ul>
        </div>
    );
}

const mapStateToProps = (state) => ({
    currentEvent: state.event.current,
});

export default connect(mapStateToProps)(withRouter(Navigation));
